import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <section className="w-full px-4 md:px-6 py-8 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', path: '/' },
                { label: '关于我们' },
              ]}
            />

            <div className="mt-4 mb-10">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                关于91影视看片app
              </h1>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                一款致力于为用户提供免费高清影视观看体验的手机应用
              </p>
            </div>

            <BrandIntro />
            <Reputation />
            <ContactSection />
          </div>
        </section>

        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于91影视看片app",
            "description": "91影视看片app是一款免费高清影视在线观看应用，支持安卓和苹果设备，提供海量影视资源每日更新。",
            "url": "https://www.91yingshi.com/about",
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://www.91yingshi.com/" },
                { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://www.91yingshi.com/about" }
              ]
            }
          })
        }} />
      </main>
      <Footer />
    </>
  );
}

function BrandIntro() {
  return (
    <section className="mb-14">
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
        品牌介绍
      </h2>

      <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              91影视看片app诞生于对影视内容的热爱。我们的团队由一群资深影视爱好者和技术专家组成，致力于打造一款真正免费的、高品质的移动观影平台。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              自上线以来，91影视看片app始终坚持"免费、高清、流畅"的产品理念，不断优化用户体验。目前平台已收录超过<strong className="text-primary-600">10万部影视资源</strong>，累计服务超过<strong className="text-primary-600">5000万用户</strong>，日均活跃用户突破800万。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              我们拥有专业的内容运营团队，每日更新热门电影、电视剧、综艺和动漫资源，确保用户能够第一时间观看到最新、最热门的影视内容。
            </p>
          </div>
          <div className="aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20tech%20office%20with%20warm%20ambient%20lighting%2C%20team%20collaboration%20scene%2C%20large%20screens%20displaying%20movie%20posters%2C%20creative%20workspace%20with%20plants%2C%20professional%20photography%2C%20inviting%20atmosphere&width=800&height=600&seq=about-brand-01&orientation=landscape"
              alt="91影视看片app团队"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
        {[
          { icon: 'ri-team-line', title: '专业团队', desc: '100+技术运营成员' },
          { icon: 'ri-timer-flash-line', title: '极速更新', desc: '每日实时同步最新资源' },
          { icon: 'ri-server-line', title: '全球加速', desc: 'CDN智能分发技术' },
          { icon: 'ri-customer-service-2-line', title: '用心服务', desc: '7x24小时在线客服' },
        ].map((item, i) => (
          <div key={i} className="text-center p-5 bg-background-50 border border-background-200/70 rounded-xl">
            <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
              <i className={`${item.icon} text-lg`}></i>
            </div>
            <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
            <p className="text-xs text-foreground-500">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function Reputation() {
  const reviews = [
    {
      name: '王**',
      date: '2026-07-25',
      rating: 5,
      content: '用了大半年了，资源更新真的快，画质也很清晰。免费能做成这样真的很良心了，推荐给身边好多朋友了。',
    },
    {
      name: '李**',
      date: '2026-07-20',
      rating: 5,
      content: '之前用别的app动不动就收费，91影视完全免费而且没有广告弹窗，观影体验太好了。离线缓存功能也特别好用，在地铁上也能看。',
    },
    {
      name: '张**',
      date: '2026-07-18',
      rating: 5,
      content: '苹果和安卓都用过，都很流畅。界面设计简洁大方，老人小孩都能轻松上手。资源分类也很清晰，找片方便。',
    },
    {
      name: '刘**',
      date: '2026-07-15',
      rating: 4,
      content: '整体体验很好，资源丰富更新快。希望后续能增加更多纪录片和学习类视频资源，现在的内容以娱乐为主。',
    },
    {
      name: '陈**',
      date: '2026-07-12',
      rating: 5,
      content: '投屏功能太赞了！下班回家就把手机上的电影投到电视上，一家人一起看。画质清晰流畅，比很多付费软件还好用。',
    },
    {
      name: '赵**',
      date: '2026-07-10',
      rating: 5,
      content: '作为追剧党，这个app真的是福音。国产剧韩剧美剧应有尽有，更新速度也很快。已经安利给整个宿舍的同学了！',
    },
  ];

  return (
    <section className="mb-14">
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
        用户口碑
      </h2>

      <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 mb-6">
        <div className="flex flex-col sm:flex-row items-center gap-6 mb-8">
          <div className="text-center">
            <div className="text-4xl font-heading font-bold text-primary-600">4.9</div>
            <div className="flex items-center justify-center gap-0.5 mt-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-yellow-500 text-sm"></i>
              ))}
            </div>
            <div className="text-xs text-foreground-500 mt-1">综合评分</div>
          </div>
          <div className="flex-1 w-full">
            {[5, 4, 3, 2, 1].map((star) => {
              const percentages = [82, 14, 3, 1, 0];
              return (
                <div key={star} className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-500 w-8 text-right whitespace-nowrap">{star}星</span>
                  <div className="flex-1 h-2 bg-background-200 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-yellow-500 rounded-full transition-all duration-500"
                      style={{ width: `${percentages[5 - star]}%` }}
                    ></div>
                  </div>
                  <span className="text-xs text-foreground-400 w-10 whitespace-nowrap">{percentages[5 - star]}%</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {reviews.map((review, i) => (
          <div key={i} className="bg-background-50 border border-background-200/70 rounded-xl p-5">
            <div className="flex items-center justify-between mb-3">
              <span className="font-medium text-foreground-900 text-sm">{review.name}</span>
              <span className="text-xs text-foreground-400">{review.date}</span>
            </div>
            <div className="flex items-center gap-0.5 mb-2">
              {Array.from({ length: 5 }).map((_, j) => (
                <i
                  key={j}
                  className={`text-xs ${j < review.rating ? 'ri-star-fill text-yellow-500' : 'ri-star-line text-foreground-300'}`}
                ></i>
              ))}
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">{review.content}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value.trim();
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('phone_alt');

      const url = 'https://readdy.ai/api/form/d9oda1e8mbnljin5abo0';

      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value as string);
      });

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        setFormError(msg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <section className="mb-14" id="contact">
      <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
        联系我们
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">联系方式</h3>
          <div className="flex flex-col gap-4">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-900">电子邮箱</div>
                <div className="text-sm text-foreground-500">support@91yingshi.com</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-customer-service-2-line text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-900">在线客服</div>
                <div className="text-sm text-foreground-500">7x24小时全天候服务</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-question-answer-line text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-900">常见问题</div>
                <div className="text-sm text-foreground-500">
                  <Link to="/" className="text-primary-600 hover:underline">查看FAQ获取帮助</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl p-6">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">给我们留言</h3>

          {formStatus === 'success' && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-green-600"></i>
                <span className="text-sm text-green-700 font-medium">留言已成功提交！我们会尽快回复您。</span>
              </div>
            </div>
          )}

          {formStatus === 'error' && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
              <div className="flex items-center gap-2">
                <i className="ri-error-warning-line text-red-600"></i>
                <span className="text-sm text-red-700">{formError}</span>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} id="contact-form" data-readdy-form="">
            <div className="honeypot-field">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="请输入您的邮箱"
                />
              </div>
            </div>
            <div className="mb-4">
              <label htmlFor="contact-subject" className="block text-sm text-foreground-700 mb-1.5">主题</label>
              <input
                id="contact-subject"
                name="subject"
                type="text"
                required
                className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                placeholder="请输入留言主题"
              />
            </div>
            <div className="mb-5">
              <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-1.5">留言内容</label>
              <textarea
                id="contact-message"
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-3 py-2.5 text-sm border border-background-300 rounded-lg bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                placeholder="请输入您的留言内容（最多500字）"
              ></textarea>
            </div>
            <button
              type="submit"
              className="whitespace-nowrap w-full bg-primary-500 hover:bg-primary-600 text-white font-medium py-2.5 rounded-lg text-sm transition-colors duration-200 cursor-pointer"
            >
              提交留言
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}